"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function tokenize(input) {
    return input.match(/[a-z]+|([A-Z][a-z]+)|([A-Z]+)/g) || [input];
}
exports.tokenize = tokenize;
//# sourceMappingURL=tokenize.js.map